module.exports = __webpack_public_path__ + "static/charity-water-a0a3b17f326a59464aca78c2e98a313a.jpg";